<template>
  <table class="report-table">
    <thead>
      <tr>
        <th></th>
        <template v-for="mealEvent in mealEvents">
          <th :key="mealEvent.id">{{ $t(`orderReport.${mealEvent.name.toLowerCase()}`) }}</th>
        </template>
      </tr>
    </thead>
    <tbody>
      <template v-for="(day, key) in getOrdersByDate">
        <tr :key="key">
          <td colspan="4" class="innerCaption">
            {{ $t(`orderReport.${getWeekday(key)}`) }}
          </td>
        </tr>
        <template v-for="diet in diets">
          <tr :key="`${key}-${diet.name}`">
            <td>
              {{ $t(`orderReport.${[diet.name.toLowerCase()]}`) }}
            </td>
            <template v-for="mealEvent in mealEvents">
              <td :key="`${key}-${diet.name}-${mealEvent.id}`">
                {{ mealsForEventAndDiet(day, mealEvent, diet.name) }}
              </td>
            </template>
          </tr>
        </template>
        <tr :key="`totalForDay-${key}`" class="totals">
          <td>{{ $t('orderReport.totalFor') }} {{ $t(`orderReport.${getWeekday(key)}`) }}</td>
          <template v-for="mealEvent in mealEvents">
            <td :key="mealEvent.id">{{ getTotalByEventForDay(mealEvent, key) }}</td>
          </template>
        </tr>
      </template>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="4" class="innerCaption">
          {{ $t(`orderReport.week`) }}
        </td>
      </tr>
      <tr class="totals">
        <td>{{ $t('orderReport.totals') }}</td>
        <template v-for="mealEvent in mealEvents">
          <td :key="mealEvent.id">{{ getTotalByEvent(mealEvent) }}</td>
        </template>
      </tr>
    </tfoot>
  </table>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import moment from 'moment';
import { getTotalsByEvent, groupOrdersByPath } from '@/helpers';

export default {
  computed: {
    ...mapGetters('orders', { orders: 'getWeekOrders' }),
    ...mapState('diets', { diets: (state) => state.diets }),
    ...mapState('events', { mealEvents: (state) => state.mealEvents }),
    getOrdersByDate() {
      return groupOrdersByPath(this.orders, 'menuInfo.date');
    },
  },
  methods: {
    mealsForEventAndDiet(orders, mealEvent, diet) {
      if (Object.keys(orders).length === 0) return 0;

      const filteredByEvent = orders.filter((item) => item.menuInfo.event === mealEvent.id);
      const filteredByDiet = filteredByEvent.filter((order) => {
        const dietName = order.mealInfo.dietInfo.name;
        return dietName === diet;
      });
      return filteredByDiet && filteredByDiet.length > 0 ? filteredByDiet.length : null;
    },
    getWeekday(date) {
      return moment(date)
        .format('dddd')
        .toLowerCase();
    },
    getTotalByEvent(mealEvent) {
      return getTotalsByEvent(mealEvent, this.orders);
    },
    getTotalByEventForDay(mealEvent, day) {
      return getTotalsByEvent(mealEvent, this.getOrdersByDate[day]);
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../scss/variables';
.report-table {
  width: 100%;
  th:not(:empty),
  td {
    border: 1px solid $order-report-table-color;
    padding: 1em;
  }
  .totals {
    font-weight: 500;
  }
}
.innerCaption {
  text-align: center;
  background-color: $order-report-table-color;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/table/ReportTable.vue